import type { BulkPricedCashNettedLeg } from '@/store/bulkTrade/state.ts';
import type { AppState } from '@/store/store.ts';
import { convertPointsToRate } from '@/utils/number-point.ts';

export const selectBulkTrade = (state: AppState, tabId: string) => state.bulkTrade[tabId];

export const getNettedLegSpot = (leg: BulkPricedCashNettedLeg) => {
  const spotWithoutMargin =
    leg.quoteLeg.CustomerWay === 'Buy' ? leg.quoteLeg.SpotWithMargin.Ask : leg.quoteLeg.SpotWithMargin.Bid;

  return Number(spotWithoutMargin) + convertPointsToRate(leg.spotCommercialMarginPPS, 6, 5);
};

export const getNettedLegAllIn = (leg: BulkPricedCashNettedLeg) => {
  const spotWithoutMargin =
    leg.quoteLeg.CustomerWay === 'Buy' ? leg.quoteLeg.SpotWithMargin.Ask : leg.quoteLeg.SpotWithMargin.Bid;

  const forwardPoints =
    leg.quoteLeg.CustomerWay === 'Buy' ? leg.quoteLeg.ForwardPoints.Ask : leg.quoteLeg.ForwardPoints.Bid;

  return Number(spotWithoutMargin) + convertPointsToRate(leg.spotCommercialMarginPPS + Number(forwardPoints), 6, 5);
};

export const getNettedLegCommercialMargin = (leg: BulkPricedCashNettedLeg) => {
  const forwardPoints =
    leg.quoteLeg.CustomerWay === 'Buy' ? leg.quoteLeg.ForwardPoints.Ask : leg.quoteLeg.ForwardPoints.Bid;

  return Number(leg.quoteLeg.Amount) * convertPointsToRate(leg.spotCommercialMarginPPS + Number(forwardPoints), 6, 5);
};
